import React from "react";
import { useLocation } from "react-router-dom";
import { useFeatureFlags } from "../contexts/FeatureFlagsContext";
import FeatureUnavailable from "./FeatureUnavailable";

export default function SiteFeatureRouteGuard({ session, profile, children }) {
  const location = useLocation();
  const { ready, isEnabled, flagForPath } = useFeatureFlags();
  if (!ready) return children;
  const flag = flagForPath(location.pathname);
  if (flag && !isEnabled(flag)) {
    return <FeatureUnavailable session={session} profile={profile} intranet={location.pathname.startsWith("/intranet")} management={location.pathname.startsWith("/intranet/management") || location.pathname.startsWith("/intranet/disciplinaries")} />;
  }
  return children;
}
